import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/ionic-app/why-choose.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "gatsby";

function Whychoooseionic() {
  return (
    <section
      className="why_chooose_ionic p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose <span>TekRevol for Developing Ionic Apps</span> for
              Your Business Needs?
            </h2>
            <p>
              Hire our developers today and see your unrealistic idea come to
              life.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              At TekRevol, we take pride in being one of the leading forces
              within the U.S. app development landscape; our expertise in Ionic
              development is just another proof of that.
            </p>
            <p>
              You are not hiring developers, but you are working with a top-tier
              team that is committed to delivering nothing but the best in every
              aspect of your project.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              spaceBetween={20}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                },
                1600: {
                  slidesPerView: 3,
                },
              }}
              className="slider-ionic"
            >
              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">01</div>
                  <div className="ionic-content">
                    <h5>Certified Developers</h5>
                    <p>
                      Our team is comprised of certified ionic developers with
                      proven expertise in creating high-performance
                      applications.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">02</div>
                  <div className="ionic-content">
                    <h5>Agile development</h5>
                    <p>
                      While creating your ionic apps, we make sure that they are
                      flexible and easily adaptable to changes quickly.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">03</div>
                  <div className="ionic-content">
                    <h5>Flexible Hiring Models</h5>
                    <p>
                      At TekRevol, we give you a range of hiring models tailored
                      to your specific needs, whether you need full-time
                      dedicated developers, part-time resources, or a
                      project-based team.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">04</div>
                  <div className="ionic-content">
                    <h5>Simple Pricing</h5>
                    <p>
                      The pricing model we have is straightforward with no
                      hidden charges for our clients.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">05</div>
                  <div className="ionic-content">
                    <h5>Security of Clients</h5>
                    <p>
                      For us, our client’s privacy and security are a priority.
                      All our projects are carried out through protected
                      contracts to keep your business information private.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">01</div>
                  <div className="ionic-content">
                    <h5>Certified Developers</h5>
                    <p>
                      Our team is comprised of certified ionic developers with
                      proven expertise in creating high-performance
                      applications.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">02</div>
                  <div className="ionic-content">
                    <h5>Agile development</h5>
                    <p>
                      While creating your ionic apps, we make sure that they are
                      flexible and easily adaptable to changes quickly.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">03</div>
                  <div className="ionic-content">
                    <h5>Flexible Hiring Models</h5>
                    <p>
                      At TekRevol, we give you a range of hiring models tailored
                      to your specific needs, whether you need full-time
                      dedicated developers, part-time resources, or a
                      project-based team.
                    </p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">04</div>
                  <div className="ionic-content">
                    <h5>Simple Pricing</h5>
                    <p>
                      The pricing model we have is straightforward with no
                      hidden charges for our clients.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="ionic-box">
                  <div className="ionic-num">05</div>
                  <div className="ionic-content">
                    <h5>Security of Clients</h5>
                    <p>
                      For us, our client’s privacy and security are a priority.
                      All our projects are carried out through protected
                      contracts to keep your business information private.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book a call with our Ionic Developers
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoooseionic;
